export default "<span *ngIf=\"score\">\r\n  {{title}} {{score}}\r\n</span>\r\n";